import ProfileRoute from './ProfileRoute';

export default ProfileRoute;
